let token;

export * from './projects';
export * from './balances';
export * from './markets';
export * from './users';
export * from './alerts';
export * from './utils';
export const getToken = () => token
export const saveToken = (_token) => token = _token